import moment from 'moment/moment';

export const getDurationWithMainHours = (dur, isSeconds) => {
  const localDur = isSeconds ? dur * 1000 : dur;
  const duration = moment.duration(localDur);
  const minutes = duration.get('minutes');
  const seconds = duration.get('seconds');
  let hours = Math.floor(duration.subtract(minutes, 'm').subtract(seconds, 's').asHours());

  hours = hours > 0 ? hours <= 9 ? `0${hours}:` : `${hours}:` : '00:';

  return `${hours}${minutes > 0 ? `${moment(minutes, 'm').format('mm')}:` : '00:'}${seconds > 0 ? moment(seconds, 's').format('ss') : '00'}`;
};

export const getEndOfDay = (momentDate, asString = true) => {
  const timestamp = momentDate.utc().endOf('day').valueOf();

  return asString ? timestamp.toString() : timestamp;
};

export const getStartOfDay = (momentDate, asString = true) => {
  const timestamp = momentDate.utc().startOf('day').valueOf();

  return asString ? timestamp.toString() : timestamp;
};

export const timestampOffset = (timestamp, offset) => timestamp + (3600000 * offset);
export const timestampOffsetUtc = (timestamp, offset) => timestamp + (3600 * offset);

export const makeRangeToNow = (minutes, utcOffset = 0) => {
  let start = moment().subtract(minutes, 'm').startOf('m').valueOf();
  let end = moment().startOf('m').valueOf();

  if (utcOffset !== 0) {
    start = timestampOffset(start, utcOffset);
    end = timestampOffset(end, utcOffset);
  }

  return { start, end };
};

export const makeRangeToNowForPM = (minutes, utcOffset = 0) => {
  let start = moment().startOf('m').subtract(minutes, 'm').valueOf();
  let end = moment().startOf('m').valueOf();

  if (utcOffset !== 0) {
    start = timestampOffset(start, utcOffset);
    end = timestampOffset(end, utcOffset);
  }

  return { start, end };
};

export const formatTSMilliseconds = (ts) => {
  const momentInst = moment(ts).utc();

  return `${momentInst.format('L')} ${momentInst.format('LTS')}`;
};

export const getLocalTimeZoneOffset = () =>
  (new Date()).getTimezoneOffset();

export const getLocalTimeZone = () => {
  const offset = -getLocalTimeZoneOffset();
  const hours = Math.trunc(offset / 60);
  const minutes = Math.abs(offset % 60);

  return [hours, minutes];
};

export const timeZoneToString = (hours, minutes) =>
    `${hours < 0 ? '-' : '+'}${Math.abs(hours) < 10 ? '0' : ''}${Math.abs(hours)}:${minutes === 0 ? '00' : minutes}`;

export const getLocalTimeZoneString = () =>
  timeZoneToString(...getLocalTimeZone());

export const getTheLastNdaysInSeconds = (n) => moment().utc().subtract(n, 'd').startOf('day')
    .unix()
    .toString();

export const getTheLastNdaysInMilliseconds = (n, units = 'd') => moment().utc().subtract(n, units).startOf('day')
    .valueOf()
    .toString();

export const getEndOfDayInSeconds = (momentDate, asString = true) => {
  const timestamp = momentDate.utc().endOf('day').unix();

  return asString ? timestamp.toString() : timestamp;
};
